import tagsService from "api/tagsService";
import { ITag } from "dto/ITag";
import moment from "moment";
import {
  MutableRefObject,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import Chip from "components/Chip";
import CertContext from "contexts/CertContext";
import MenuContext from "contexts/MenuContext";
import PackagesContext from "contexts/PackagesContext";
import sanitizeHtml from "sanitize-html";
import EventContext from "contexts/EventContext";
import { ItemKind } from "dto/IKindItems";
import { Tooltip } from "@mui/material";
import { useInView } from "framer-motion";
import { useTranslation } from "react-i18next";

const HelpdeskIssueCard: FC<Props> = ({
  onClick,
  msg,
  statuses,
  tags,
  keys,
  isFirst = false,
  decodedContent,
  isSelectable = false,
  selectedElements,
  setSelectedElements,
  onPreview,
  selectMultiple,
  scrollWrapper,
  showS = true,
  remove,
}) => {
  const { t } = useTranslation();
  const { threadPackageId } = useParams();
  let { packageId } = useParams();

  packageId = encodeURIComponent(packageId ?? "");

  tagsService.useRemoveTagFromPackage();
  const [findedTags] = useState<ITag[]>([]);
  const refWrapper = useRef(null);

  const [, setShowEditTags] = useState(false);

  const isSelected = !!selectedElements?.find((s) => s.Id === msg.Id) ?? false;

  // Use object destructuring, so you don't need to remember the exact order
  const inView = useInView(refWrapper, { root: scrollWrapper });

  useEffect(() => {
    if (isSelected && !inView) {
      console.log("Scroll to element");
      refWrapper?.current.scrollIntoView();
    }
  }, [isSelected]);

  // useEffect(() => {
  //   const t = tags?.filter((tag) =>
  //     msg?.TagIds?.find((iTag) => tag.Id === iTag)
  //   );
  //   setFindedTags(t);
  //   const newStatus = statuses?.find((s) => s.Id === msg.StatusId);

  //   setStatus(newStatus ?? null);
  // }, [msg, statuses, msg.StatusId, msg.TagIds]);

  const { packages, setPackages } = useContext(PackagesContext);
  const [showOptions, setShowOptions] = useState(false);
  useContext(MenuContext);

  // useEffect(() => {
  //   if (id !== msg.Id) {
  //     setShowOptions(false);
  //   }
  // }, [id]);

  useContext(CertContext);

  useContext(EventContext);

  const handleClick = (e) => {
    //navigate(`/helpdesk/issues/${msg.ChatId}`);
  };

  const isCurrentDate = moment(msg?.CreationDate ?? msg?.CreationDate).isSame(
    new Date(),
    "day"
  );

  const isTomorrow = moment(msg?.CreationDate ?? msg?.CreationDate).isSame(
    moment(new Date()).subtract(1, "day").startOf("day"),
    "day"
  );

  const time = msg?.CreationDate ?? new Date();

  // if (listFilter?.type === ETypeOfOrder.CREATION_DATE) {
  //   time = msg.CreationDate;
  // }

  let data = "";

  data = moment(time).format("DD.MM.YY").toString();

  if (isCurrentDate) {
    data = `Dzisiaj | ${moment(time).format("HH:mm").toString()}`;
  }

  if (isTomorrow) {
    data = `Wczoraj | ${moment(time).format("HH:mm").toString()}`;
  }

  useEffect(() => {
    if (!msg) return;
    if (packageId === msg.Id || msg.Id === threadPackageId) {
      setShowOptions(true);
    }

    if (showOptions && packageId !== msg.Id && msg.Id !== threadPackageId) {
      setShowOptions(false);
    }

    const newPacks = [...packages];
    const actual = newPacks?.find((a) => a.Id === packageId);

    if (!actual) return;

    if (
      actual.Kind !== ItemKind.EDeliveryMessage &&
      actual.Kind !== ItemKind.CourtPortalDeliverance
    ) {
      actual.Unread = false;

      setPackages(newPacks);
    }
  }, [packageId, threadPackageId]);

  const handleClickRightButton = () => {
    if (msg.Id === packageId) return;
    setShowOptions(true);
    setIsRightClicked(true);
  };

  // useEffect(() => {
  //   if (msg.Id === packageId || msg.Id === threadPackageId) {
  //     setSelectedElements([msg]);
  //   }
  // }, []);

  const [, setIsRightClicked] = useState(false);

  const [isMouse, setIsMouse] = useState(false);

  const contentRef = useRef<HTMLDivElement>(null);
  const [, setTagPopperRef] =
    useState<MutableRefObject<HTMLDivElement>>(null);
  const iconsRef = useRef<HTMLDivElement>(null);
  const tagsRef = useRef<HTMLDivElement>(null);

  const createRipple = (event: MouseEvent) => {
    const button = event.currentTarget as HTMLElement;
    const ripple = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${event.clientX - button.offsetLeft - radius}px`;
    ripple.style.top = `${event.clientY - button.offsetTop - radius}px`;
    ripple.classList.add(styles.ripple);

    const rippleContainer = button.querySelector(`.${styles.rippleContainer}`);
    rippleContainer?.appendChild(ripple);

    setTimeout(() => {
      ripple.remove();
    }, 600);
  };

  return (
    <div ref={contentRef} tabIndex={0} className={`${styles.msgWrapper}`}>
      <div
        data-id={msg.Id}
        onMouseEnter={() => setIsMouse(true)}
        onMouseLeave={() => setIsMouse(false)}
        onContextMenu={(e) => {
          e.preventDefault();
          handleClickRightButton();
        }}
      >
        <div
          className={`${styles.rippleContainer}`}
          onClick={(e: any) => {
            createRipple(e);
          }}
        >
          <div
            ref={refWrapper}
            onClick={
              onClick
                ? (e: any) => {
                    const ele = e.target.tagName.toLowerCase();
                    const button = e.target.outerHTML.search("button") !== -1;

                    if (ele !== "div" || button) {
                      return;
                    }

                    onClick?.();
                  }
                : handleClick
            }
            className={`${styles.card}`}
          >
            {msg.Unread && (
              <Tooltip title={t("chat.unreadInTicket")}>
                <div className={styles.colorBar}></div>
              </Tooltip>
            )}
            {/* {!msg.Unread && (
              <>
                {isIncoming && !msg.IsIncoming && !msg.IsForwarded && (
                  <div className={styles.directionIcon}>
                    <ReplyIcon />
                  </div>
                )}
                {((isIncoming && !msg.IsIncoming && msg.IsForwarded) ||
                  msg.Pass) && (
                  <div className={styles.directionIcon}>
                    <ForwardIcon />
                  </div>
                )}
              </>
            )} */}
            {/* {msg?.Thread?.Count > 1 && msg?.Thread?.UnreadCount > 0 && (
              <div className={styles.colorBar}>
                {msg?.Thread?.UnreadCount ?? 0}
              </div>
            )} */}
            {/* <div
              style={{ backgroundColor: statusColor }}
              className={styles.statusBar}
            ></div> */}
            <div className={`${styles.header}`}>
              <div className={styles.headerWrapper}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: msg.Number,
                  }}
                  className={styles.sender}
                ></div>
              </div>
              <div className={styles.dateWrapper}>
                <div className={styles.date}>{data}</div>
              </div>
            </div>
            <div className={styles.titleWrapper}>
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(msg.Title),
                }}
                className={styles.title}
              ></div>
              <div className={`${styles.icons}`} ref={iconsRef}>
                {/* <IconsState
                  onDownload={onDownload}
                  onPreview={onPreview}
                  keys={keys}
                  msg={msg}
                  inDeskView={inDeskView}
                  setShowEditStatus={(show) => {
                    if (show) {
                      setStatusPopperRef(iconsRef);
                    }

                    setShowEditStatus(show);
                  }}
                /> */}
              </div>
            </div>
            <div className={styles.tagRow}>
              <div className={styles.tags} ref={tagsRef}>
                {findedTags.map((tag) => (
                  <Chip
                    onClick={() => {
                      setTagPopperRef(tagsRef);
                      setShowEditTags(true);
                    }}
                    small
                    outlined={false}
                    element={<>{tag.Name}</>}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div
          className={`${styles.separator} ${
            !!findedTags.length && styles.sep
          } ${isMouse && styles.hideSep} `}
        ></div>
      </div>

      {/* {showEditStatus && (
        <Popper
          anchorEl={statusPopperRef?.current ?? contentRef?.current}
          open={showEditStatus}
          setOpen={setShowEditStatus}
        >
          <StatusModal
            item={msg}
            toggle={setShowEditStatus}
            selectedStatus={status}
            afterUpdate={handleStatusUpdate}
          />
        </Popper>
      )} */}
      {/* {showEditTags && (
        <Popper
          anchorEl={tagPopperRef?.current ?? contentRef?.current}
          open={showEditTags}
          setOpen={setShowEditTags}
        >
          <ChooseTagNew
            toTag={msg}
            toggle={setShowEditTags}
            updateTags={handleUpdateTags}
            type={TagType.Incoming}
          />
        </Popper>
      )} */}
    </div>
  );
};

export default HelpdeskIssueCard;
